// extracted by mini-css-extract-plugin
export var container = "_sg-0";
export var table = "_sg-2";
export var tableWrapper = "_sg-1";